import {
    $applyNodeReplacement, $createParagraphNode,
    $isTextNode,
    DOMConversionMap, DOMConversionOutput, DOMExportOutput,
    EditorConfig, ElementFormatType,
    ElementNode,
    LexicalEditor, LexicalNode, ParagraphNode,
    RangeSelection,
    SerializedElementNode, SerializedParagraphNode
} from 'lexical';

// import {isHTMLElement} from '@lexical/utils'

// export type SerializedParagraphNode = SerializedElementNode;

export class CustomParagraphNode extends ParagraphNode {
    static getType(): string {
        return 'custom-paragraph';
    }

    static clone(node: CustomParagraphNode): CustomParagraphNode {
        return new CustomParagraphNode(node.__key);
    }

    // View

    createDOM(config: EditorConfig): HTMLElement {
        const dom       = document.createElement('div')
        const theme = config.theme
        const className = theme.paragraph
        if (className !== undefined) {
            dom.className = className
        }
        return dom
    }

    /*updateDOM(
        prevNode: CustomParagraphNode,
        dom: HTMLElement,
        config: EditorConfig,
    ): boolean {
        return false;
    }

    static importDOM(): DOMConversionMap | null {
        return {
            p: (node: Node) => ({
                conversion: convertParagraphElement,
                priority: 0,
            }),
        };
    }

    exportDOM(editor: LexicalEditor): DOMExportOutput {
        const {element} = super.exportDOM(editor);

        if (element && isHTMLElement(element)) {
            if (this.isEmpty()) element.append(document.createElement('br'));

            const formatType = this.getFormatType();
            element.style.textAlign = formatType;

            const direction = this.getDirection();
            if (direction) {
                element.dir = direction;
            }
            const indent = this.getIndent();
            if (indent > 0) {
                // padding-inline-start is not widely supported in email HTML, but
                // Lexical Reconciler uses padding-inline-start. Using text-indent instead.
                element.style.textIndent = `${indent * 20}px`;
            }
        }

        return {
            element,
        };
    }*/

    static importJSON(serializedNode: SerializedParagraphNode): CustomParagraphNode {
        const node = $createParagraphNode()
        node.setFormat(serializedNode.format)
        node.setIndent(serializedNode.indent)
        node.setDirection(serializedNode.direction)
        return node
    }

    exportJSON(): SerializedParagraphNode {
        return {
            ...super.exportJSON(),
            type    : CustomParagraphNode.getType(),
            version : 1,
        };
    }

    // Mutation

    /*insertNewAfter(_: RangeSelection, restoreSelection: boolean): CustomParagraphNode {
        const newElement = $createParagraphNode();
        const direction = this.getDirection();
        newElement.setDirection(direction);
        this.insertAfter(newElement, restoreSelection);
        return newElement;
    }

    collapseAtStart(): boolean {
        const children = this.getChildren();
        // If we have an empty (trimmed) first paragraph and try and remove it,
        // delete the paragraph as long as we have another sibling to go to
        if (
            children.length === 0 ||
            ($isTextNode(children[0]) && children[0].getTextContent().trim() === '')
        ) {
            const nextSibling = this.getNextSibling();
            if (nextSibling !== null) {
                this.selectNext();
                this.remove();
                return true;
            }
            const prevSibling = this.getPreviousSibling();
            if (prevSibling !== null) {
                this.selectPrevious();
                this.remove();
                return true;
            }
        }
        return false;
    }*/
}

/*function convertParagraphElement(element: HTMLElement): DOMConversionOutput {
    const node = $createParagraphNode();
    if (element.style) {
        node.setFormat(element.style.textAlign as ElementFormatType);
        const indent = parseInt(element.style.textIndent, 10) / 20;
        if (indent > 0) {
            node.setIndent(indent);
        }
    }
    return {node};
}

export function $createParagraphNode(): CustomParagraphNode {
    return $applyNodeReplacement(new CustomParagraphNode());
}

export function $isParagraphNode(
    node: LexicalNode | null | undefined,
): node is CustomParagraphNode {
    return node instanceof CustomParagraphNode;
}*/
